<template>
    <div>
        <img src="@/assets/images/img-otp.svg" alt="OTP image" class="mx-auto pb-2" />

        <p class="regular blue-dark mt-8 pb-2">
            {{ $t('otp.caption') }} <strong>{{ profile.phoneNumber }}</strong>
        </p>

        <div class="flex justify-between mt-8 mb-4">
            <input
                v-model="codes[0]"
                type="number"
                tabindex="1"
                autofocus
                autocomplete="one-time-code"
                step="1" min="0" max="9" maxlength="1"
                class="text-center"
                @input="onInput"
                @click="onFocus"
            />

            <input
                v-model="codes[1]"
                type="number"
                tabindex="2"
                autocomplete="noauto"
                class="text-center"
                step="1" min="0" max="9" maxlength="1"
                @input="onInput"
                @click="onFocus"
            />

            <input
                v-model="codes[2]"
                type="number"
                tabindex="3"
                autocomplete="noauto"
                class="text-center"
                step="1" min="0" max="9" maxlength="1"
                @input="onInput"
                @click="onFocus"
            />

            <input
                v-model="codes[3]"
                type="number"
                tabindex="4"
                autocomplete="noauto"
                class="text-center"
                step="1" min="0" max="9" maxlength="1"
                @input="onInput"
                @click="onFocus"
            />

            <input
                v-model="codes[4]"
                type="number"
                tabindex="5"
                autocomplete="noauto"
                class="text-center"
                step="1" min="0" max="9" maxlength="1"
                @input="onInput"
                @click="onFocus"
            />

            <input
                v-model="codes[5]"
                type="number"
                tabindex="6"
                autocomplete="noauto"
                class="text-center"
                step="1" min="0" max="9" maxlength="1"
                @input="onInput"
                @click="onFocus"
            />
        </div>

        <p class="normal error" v-if="errors.length > 0">
            <ol>
                <template v-for="(error, i) in errors">
                    <li :key="`error-${i}`">{{ error }}</li>
                </template>
            </ol>
        </p>

        <p class="normal grey-light mt-4 text-center pb-2">
            <span v-if="otpTimeout > 0">{{ $t('otp.resend_in') }} {{ countdown }}</span>
            <span v-if="otpTimeout <= 0" class="cursor-pointer" @click="resend">{{ $t('otp.resend') }}</span>
        </p>

        <button class="w-full rounded mt-8" :disabled="!otpFilled" @click="signup">{{ $t('otp.signup') }}</button>
    </div>
</template>

<style lang="scss" scoped>
input {
    width: 40px;
    height: 40px;
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>

<script>
import Store from '@/store'
import Router from '@/routes'

const MIN = 0;
const MAX = 9;

export default {
    data () {
        return {
            codes: [],
            inputBoxes: [],
            countdown: '00:00',
            timer: null,
            errors: []
        }
    },
    computed: {
        profile () {
            return this.$store.state.profile
        },
        otpTimeout: {
            get () { return this.$store.state.otpTimeout },
            set (value) { this.$store.dispatch('setOTPTimeout', value) }
        },
        otpFilled () {
            return this.codes && this.codes.join('').length === this.inputBoxes.length;
        }
    },
    mounted () {
        this.inputBoxes = document.querySelectorAll('[type="number"]')
        this.timer = setInterval(this.tick, 1000)
    },
    created () {
        this.timeLeft = this.otpTimeout
    },
    beforeDestroy () {
        clearInterval(this.timer)
        this.timer = null
    },
    methods: {
        autoFill (value) {
            this.inputBoxes[0].focus()

            for (let i = 0; i < this.inputBoxes.length; i++) {
                this.codes[i] = value[i]
            }

            this.inputBoxes[this.inputBoxes.length - 1].focus()
        },
        onFocus (e) {
            this.codes[e.target.tabIndex - 1] = ''
            e.target.value = ''
        },
        onInput (e) {
            const index = e.target.tabIndex - 1
            let value = e.target.value

            // for auto fill from OS or paste
            if (!isNaN(value.trim()) && value.trim().length >= 6) {
                this.autoFill(value)

                return
            }

            if (value.trim().length > 1) {
                value = value[value.length - 1]
                this.codes[index] = value
            }

            const numberValue = parseInt(value)

            if (!isNaN(value) && numberValue >= MIN && numberValue <= MAX) {
                let focusIndex = index + 1

                if (focusIndex > this.inputBoxes.length - 1) {
                    focusIndex = this.inputBoxes.length - 1
                }

                this.inputBoxes[focusIndex].focus()
            } else {
                this.codes[index] = 0
            }
        },
        async resend () {
            try {
                const params = Object.assign({}, this.profile);
                if (params.phoneNumber) {
                    params.phoneNumber = String(params.phoneNumber).replace('+', '')
                }

                const result = await this.$axios.post('auth/otp?isResend=true', params)

                this.otpTimeout = result.retryWaitSeconds || 60

                this.timer = setInterval(this.tick, 1000)
            } catch (e) {
                this.handleError(e.response)
            }
        },
        tick () {
            if (this.otpTimeout <= 0) {
                this.otpTimeout = 0
                clearInterval(this.timer)
                this.timer = null
            }

            const minute = parseInt(this.otpTimeout / 60);
            const seconds = parseInt(this.otpTimeout % 60);

            this.countdown = ('0' + minute).slice(-2) + ':' + ('0' + seconds).slice(-2)

            this.otpTimeout -=  1
        },
        async signup () {
            if (this.otpFilled) {
                this.$store.dispatch('setOTP', this.codes.join(''))

                try {
                    const params = Object.assign({}, this.profile);
                    if (params.phoneNumber) {
                        params.phoneNumber = String(params.phoneNumber).replace('+', '')
                    }
                    await this.$axios.post('auth/register', params)

                    this.$router.push({ path: '/download', query: { lang: Store.state.lang }})
                } catch (e) {
                   this.handleError(e.response)
                }
            }
        },
        handleError (response) {
            if (response.data.errors) {
                this.errors = response.data.errors
            } else if(response.data.message) {
                this.errors = [response.data.message]
            }
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!Store.getters.completedProfile) {
            Router.push({ path: '/', query: { lang: Store.state.lang } })
        }

        next()
    }
}
</script>
